module.exports = __webpack_public_path__ + "static/media/fbImage.a17aa755.png";